import { Route, Routes } from "react-router";
import Accounts from "./pages/accounts/accounts.page";
import AnalysisPage from "./pages/analysis";
import CreateExpensePage from "./pages/expenses/create.expense.page";
import MiscExpensesPage from "./pages/expenses/misc.expenses.page";
import GroupPage from "./pages/groups/group.page";
import Groups from "./pages/groups/groups.page";
import { DeleteAccountHelp } from "./pages/help/delete-account.help";
import { HelpHomePage } from "./pages/help/help.home";
import { ImportExpensesHelp } from "./pages/help/import-expenses.help";
import { LoginHelp } from "./pages/help/login.help";
import { RegisterHelp } from "./pages/help/register.help";
import HomePage from "./pages/home.page";
import LedgerViewPage from "./pages/ledgers/ledger.view.page";
import LedgersPage from "./pages/ledgers/ledgers.page";
import NoAccessPage from "./pages/no-access.page";
import ProfilePage from "./pages/profile";
import Savings from "./pages/savings/savings.page";
import SavingsGoalViewPage from "./pages/savings-goals/savings.goal.view.page";
import SearchExpenses from "./pages/search.expenses.page";
import SubscriptionsPage from "./pages/subscriptions/subscriptions";
import SubscriptionsCreatePage from "./pages/subscriptions/subscriptions.create.page";
import SubscriptionsSuccessPage from "./pages/subscriptions/subscriptions.success.page";
import TripViewPage from "./pages/trips/trip.view.page";
import Trips from "./pages/trips/trips.page";
import IncomesPage from "./pages/incomes/incomes.page";
import Notifications from "./pages/notifications/notifications.page";

export const AuthenticatedRoutes = () => {
  const groupsSubRoutes = (
    <Routes>
      <Route path="/:gid" element={<GroupPage />} />
      <Route path="/" element={<Groups />} />
    </Routes>
  );

  const helpSubRoutes = (
    <Routes>
      <Route path="/import-expenses" element={<ImportExpensesHelp />} />
      <Route path="/login" element={<LoginHelp />} />
      <Route path="/register" element={<RegisterHelp />} />
      <Route path="/delete-account" element={<DeleteAccountHelp />} />
      <Route path="/" element={<HelpHomePage />} />
    </Routes>
  );

  return (
    <div>
      <Routes>
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/search" element={<SearchExpenses />} />
        <Route path="/expenses/create" element={<CreateExpensePage />} />
        <Route path="/savings-goals/:id" element={<SavingsGoalViewPage />} />
        <Route path="/savings" element={<Savings />} />
        <Route path="/ledgers/:id" element={<LedgerViewPage />} />
        <Route path="/ledgers" element={<LedgersPage />} />

        <Route path="/incomes" element={<IncomesPage />} />
        <Route path="/accounts" element={<Accounts />} />

        <Route path="/groups/*" element={groupsSubRoutes} />
        <Route path="/misc" element={<MiscExpensesPage />} />
        <Route path="/profile" element={<ProfilePage />} />

        <Route
          path="/subscriptions/:id/create"
          element={<SubscriptionsCreatePage />}
        />
        <Route
          path="/subscriptions/success"
          element={<SubscriptionsSuccessPage />}
        />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/trips/:id" element={<TripViewPage />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/analysis" element={<AnalysisPage />} />
        <Route path="/help/*" element={helpSubRoutes} />
        <Route path="*" element={<NoAccessPage />} />
      </Routes>
    </div>
  );
};
